import React, { useState } from 'react';
import { Tabs } from 'antd';
import UnescoConvertFetchTab from './UnescoConvertFetchTab';
import UnescoIndicatorMappingTab from './UnescoIndicatorMappingTab';
import UnescoCountryMappingTab from './UnescoCountryMappingTab';

const { TabPane } = Tabs;

const UnescoTabGroup = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [checkRefreshKey, setCheckRefreshKey] = useState(0);

  const onConvertSuccess = () => {
    setRefreshKey(prev => prev + 1);
  };

  const onCheckSuccess = () => {
    setCheckRefreshKey(k => k + 1);
  };

  return (
    <Tabs defaultActiveKey="comparison">
      <TabPane tab="Comparison" key="comparison">
        <UnescoConvertFetchTab onConvertSuccess={onConvertSuccess} refreshTrigger={checkRefreshKey} />
      </TabPane>
      <TabPane tab="Indicator Mapping" key="indicator">
        <UnescoIndicatorMappingTab refreshTrigger={refreshKey} onCheckSuccess={onCheckSuccess} />
      </TabPane>
      <TabPane tab="Country Mapping" key="country">
        <UnescoCountryMappingTab />
      </TabPane>
    </Tabs>
  );
};

export default UnescoTabGroup;
